import { Component, OnInit } from '@angular/core';
import {BasicParametersComponent} from '../../basic-parameters/basic-parameters.component';
import {PortalServiceFactoryService} from '../../../../services/portal-service-factory.service';
import {AlertaService} from '../../../../../../shared/services/alerta.service';
import {FormBuilder} from '@angular/forms';

@Component({
  selector: 'app-nrs-basic-parameters',
  templateUrl: './nrs-basic-parameters.component.html',
  styleUrls: ['./nrs-basic-parameters.component.scss']
})
export class NrsBasicParametersComponent extends BasicParametersComponent implements OnInit {

  constructor(protected fb: FormBuilder, protected portalCampFactory: PortalServiceFactoryService, protected alertHandler: AlertaService) {
      super(fb, portalCampFactory, alertHandler);

      this.form.removeControl('area_checker');
      this.form.removeControl('max_attempts');

  }

  ngOnInit() {
      this.form.controls['norm_engine'].setValue(this.portalService.getConfigKey('norm_engine', ''));
      this.form.controls['callback_response'].setValue(this.portalService.getConfigKey('callback_response', 0));
      this.form.controls['landline_verifier'].setValue(this.portalService.getConfigKey('landline_verifier', 0));
      this.form.controls['mobile_verifier'].setValue(this.portalService.getConfigKey('mobile_verifier', 1));
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/nrs/nrs-basic-parameters/nrs-basic-parameters.component.ts